// extracted by css-extract-rspack-plugin
export default {"button":"CloseButton-module__button__sm9gJ","icon":"CloseButton-module__icon__eMXCP"};